/**
 * Replacer Utility
 */

define(function(require) {
    var BaseView = require('common/base.view'),
        replacers = [
            require('replacers/bingo-replacers/bingo-bonus.view'),
            require('replacers/bingo-replacers/loyalty-info.view'),
            require('replacers/bingo-replacers/loyalty-points-redeem.view'),
            require('replacers/vip-level/vip-level.view'),
            require('replacers/comppoints/comppoints.view'),
            require('replacers/language/language-selector.view'),
            require('replacers/chat/chat.view'),
            require('replacers/date/date.view'),
            require('replacers/logout/logout.view'),
            require('replacers/user/user.replacer.view'),
            require('replacers/inbox-counter/inbox-counter.view'),
            require('replacers/pending-withdrawals-count/pending-withdrawals-count.view'),
            require('replacers/session-counter/session-counter.view'),
            require('replacers/contact-preferences/contact-preferences.view'),
            require('replacers/dynamic-currency-tag/dynamic-currency-tag.view'),
            require('replacers/get-balance/get-balance.view'),
            require('replacers/bingo-promocode/bingo.promocode.view'),
            require('replacers/lifetime-statistics/lifetime-statistics.view'),
            require('replacers/total-goldenchips-balance/total-goldenchips-balance.view'),
            require('replacers/panic-button/panic-button.view'),
            require('replacers/deposit-button/deposit-button.view'),
            require('replacers/limits-questionnarie/spanish-regulations/limits-questionnaire.view'),
            require('replacers/virtual-card/orenes-theme/virtual-card.view')
        ];

    return {
        init: function() {
            replacers.forEach(this.register.bind(this));
        },

        register: function(view) {
            view.nameOfReplacers.forEach(function(name) {
                BaseView.prototype.replacers[name] = view;
            });
        }
    };

});
